import { render, staticRenderFns } from "./menu-item-or-group.component.vue?vue&type=template&id=7b59ab45&scoped=true&"
import script from "./menu-item-or-group.component.vue?vue&type=script&lang=ts&"
export * from "./menu-item-or-group.component.vue?vue&type=script&lang=ts&"
import style0 from "./menu-item-or-group.component.vue?vue&type=style&index=0&id=7b59ab45&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b59ab45",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListGroup,VListItemContent,VListItemIcon})
